/**
 * Line-level LCS diff between two plain-text blobs (#7 v1). No deps.
 * Returns an array of hunks in document order:
 *   { type: 'equal'|'removed'|'added', left: string|null, right: string|null }
 * 'equal' -> line present in both; 'removed' -> only in left (quitado);
 * 'added' -> only in right (agregado). El pareo cambiado (ambar) lo hace la
 * capa de UI si quiere; v1 es granularidad de linea.
 */
export function diffText(leftText, rightText) {
  const left = leftText || '';
  const right = rightText || '';

  // Both empty -> single equal hunk (vacío == vacío).
  if (left === '' && right === '') {
    return [{ type: 'equal', left: '', right: '' }];
  }

  // Empty string represents zero lines (''.split('\n') would give ['']).
  const a = left === '' ? [] : left.split('\n');
  const b = right === '' ? [] : right.split('\n');
  const m = a.length;
  const n = b.length;

  // Tabla LCS (longitud de la subsecuencia comun mas larga desde i,j).
  const lcs = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = m - 1; i >= 0; i--) {
    for (let j = n - 1; j >= 0; j--) {
      lcs[i][j] = a[i] === b[j]
        ? lcs[i + 1][j + 1] + 1
        : Math.max(lcs[i + 1][j], lcs[i][j + 1]);
    }
  }

  const out = [];
  let i = 0;
  let j = 0;
  while (i < m && j < n) {
    if (a[i] === b[j]) {
      out.push({ type: 'equal', left: a[i], right: b[j] });
      i++; j++;
    } else if (lcs[i + 1][j] >= lcs[i][j + 1]) {
      out.push({ type: 'removed', left: a[i], right: null });
      i++;
    } else {
      out.push({ type: 'added', left: null, right: b[j] });
      j++;
    }
  }
  while (i < m) { out.push({ type: 'removed', left: a[i], right: null }); i++; }
  while (j < n) { out.push({ type: 'added', left: null, right: b[j] }); j++; }
  return out;
}
